var _defs, _circle, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew312({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 8,
    cy: 12.02,
    r: 1.84
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 8,
    y1: 2.14,
    x2: 8,
    y2: 10.92
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 5.86,
    y1: 4.42,
    x2: 10.14,
    y2: 4.42
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew312);
export default __webpack_public_path__ + "static/media/Symbolpack_New_312.6328dc03475fd82a8c3bc46089d2ca1e.svg";
export { ForwardRef as ReactComponent };